import { uniq } from '../lang';
import logFactory from '../logger';
import { validateSplit } from './split';
var log = logFactory('');
export function validateSplits(maybeSplits, method) {
  var listName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'split_names';
  var item = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'split name';

  if (Array.isArray(maybeSplits) && maybeSplits.length > 0) {
    var validatedArray = []; // Remove invalid values

    maybeSplits.forEach(function (maybeSplit) {
      var splitName = validateSplit(maybeSplit, method, item);
      if (splitName) validatedArray.push(splitName);
    }); // Strip off duplicated values if we have valid split names then return

    if (validatedArray.length) return uniq(validatedArray);
  }

  log.error("".concat(method, ": ").concat(listName, " must be a non-empty array."));
  return false;
}


// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio/es/utils/inputValidation/splits.js